export default __webpack_public_path__ + "static/media/electrical-map.ba5fb523.png";